import Route from 'cio/routes/base';

export default class IntegrationsTypesRoute extends Route {
  crumb() {
    let { type } = this.paramsFor('integrations.type') as Record<string, string>;

    return {
      // This reverses the serialization process on the back end
      name: type ? type.replace(/_/g, ' ') : '',
      path: 'integrations.type',
      model: type,
    };
  }
}
